"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _CommonBits = _interopRequireDefault(require("./CommonBits"));

var _CoordinateFilter = _interopRequireDefault(require("../geom/CoordinateFilter"));

var _Coordinate = _interopRequireDefault(require("../geom/Coordinate"));

var _CoordinateSequenceFilter = _interopRequireDefault(require("../geom/CoordinateSequenceFilter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var CommonBitsRemover =
/*#__PURE__*/
function () {
  function CommonBitsRemover() {
    _classCallCheck(this, CommonBitsRemover);

    CommonBitsRemover.constructor_.apply(this, arguments);
  }

  _createClass(CommonBitsRemover, [{
    key: "addCommonBits",
    value: function addCommonBits(geom) {
      var trans = new Translater(this._commonCoord);
      geom.apply(trans);
      geom.geometryChanged();
    }
  }, {
    key: "removeCommonBits",
    value: function removeCommonBits(geom) {
      if (this._commonCoord.x === 0.0 && this._commonCoord.y === 0.0) return geom;
      var invCoord = new _Coordinate.default(this._commonCoord);
      invCoord.x = -invCoord.x;
      invCoord.y = -invCoord.y;
      var trans = new Translater(invCoord);
      geom.apply(trans);
      geom.geometryChanged();
      return geom;
    }
  }, {
    key: "getCommonCoordinate",
    value: function getCommonCoordinate() {
      return this._commonCoord;
    }
  }, {
    key: "add",
    value: function add(geom) {
      geom.apply(this._ccFilter);
      this._commonCoord = this._ccFilter.getCommonCoordinate();
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return CommonBitsRemover;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return CommonBitsRemover;
}();

exports.default = CommonBitsRemover;

var CommonCoordinateFilter =
/*#__PURE__*/
function () {
  function CommonCoordinateFilter() {
    _classCallCheck(this, CommonCoordinateFilter);

    CommonCoordinateFilter.constructor_.apply(this, arguments);
  }

  _createClass(CommonCoordinateFilter, [{
    key: "filter",
    value: function filter(coord) {
      this._commonBitsX.add(coord.x);

      this._commonBitsY.add(coord.y);
    }
  }, {
    key: "getCommonCoordinate",
    value: function getCommonCoordinate() {
      return new _Coordinate.default(this._commonBitsX.getCommon(), this._commonBitsY.getCommon());
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return CommonCoordinateFilter;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [_CoordinateFilter.default];
    }
  }]);

  return CommonCoordinateFilter;
}();

CommonCoordinateFilter.constructor_ = function () {
  this._commonBitsX = new _CommonBits.default();
  this._commonBitsY = new _CommonBits.default();
};

var Translater =
/*#__PURE__*/
function () {
  function Translater() {
    _classCallCheck(this, Translater);

    Translater.constructor_.apply(this, arguments);
  }

  _createClass(Translater, [{
    key: "filter",
    value: function filter(seq, i) {
      var xp = seq.getOrdinate(i, 0) + this.trans.x;
      var yp = seq.getOrdinate(i, 1) + this.trans.y;
      seq.setOrdinate(i, 0, xp);
      seq.setOrdinate(i, 1, yp);
    }
  }, {
    key: "isDone",
    value: function isDone() {
      return false;
    }
  }, {
    key: "isGeometryChanged",
    value: function isGeometryChanged() {
      return true;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return Translater;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [_CoordinateSequenceFilter.default];
    }
  }]);

  return Translater;
}();

Translater.constructor_ = function () {
  this.trans = null;
  var trans = arguments[0];
  this.trans = trans;
};

CommonBitsRemover.CommonCoordinateFilter = CommonCoordinateFilter;
CommonBitsRemover.Translater = Translater;

CommonBitsRemover.constructor_ = function () {
  this._commonCoord = null;
  this._ccFilter = new CommonCoordinateFilter();
};